var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 5,
    viewBox: "0 0 9 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.26446 -3.61251e-07L9 0.743627L4.99129 4.79398C4.92705 4.85927 4.85067 4.91108 4.76653 4.94644C4.6824 4.9818 4.59217 5 4.50104 5C4.40991 5 4.31968 4.9818 4.23555 4.94644C4.15141 4.91108 4.07503 4.85927 4.01079 4.79398L-1.86052e-07 0.743627L0.735543 0.000700918L4.5 3.80224L8.26446 -3.61251e-07Z",
    fill: "#585D6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevronDown);
export default __webpack_public_path__ + "static/media/icon-chevron-down.17fcbf0e9da5bedaab6a52004ee1a9ea.svg";
export { ForwardRef as ReactComponent };